import { useMemo } from "react";
import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useEditions from "./useEditions";

export default function useCompareCharts( params ) {
   const { d: editions } = useEditions();
   
   // Znajdź edition_id na podstawie edition name dla obu edycji
   const edition1_id = useMemo(() => {
      if (!params?.edition || !editions) return null;
      const edition = editions.find(e => e.value === params.edition);
      return edition?.id || null;
   }, [params?.edition, editions]);
   
   const edition2_id = useMemo(() => {
      if (!params?.edition2 || !editions) return null;
      const edition = editions.find(e => e.value === params.edition2);
      return edition?.id || null;
   }, [params?.edition2, editions]);
   
   // W trybie porównania potrzebujemy key_variable_id dla obu edycji
   // params.key_variable_id to ID z edition1
   // params.key_variable_id_edition2 to ID z edition2 (ustawiane w Step2 i UDResultsMain)
   
   // Dla grouping_variable_id: w trybie porównania rok jest zawsze aktywny (nie jest w grouping_variable_ids)
   // Jeśli jest wybrana dodatkowa zmienna grupująca, to będzie ona w grouping_variable_ids
   // W trybie porównania maksymalnie 1 dodatkowa zmienna grupująca (poza rokiem)
   // Zwracamy pierwszą (i jedyną) zmienną z grouping_variable_ids, jeśli istnieje
   
   const grouping_variable_id = useMemo(() => {
      if (!params?.grouping_variable_ids || params.grouping_variable_ids.length === 0) {
         return null;
      }
      // W trybie porównania rok nie jest w grouping_variable_ids, więc pierwsza zmienna to dodatkowa
      return params.grouping_variable_ids[0] || null;
   }, [params?.grouping_variable_ids]);
   
   return useFetchData({
      APIMethod: API.getCompareCharts,
      clear_data_on_update: true,
      debounce: true,
      // Warunek: wymagamy key_variable_id i obu edition_id
      // key_variable_id_edition2 może być ustawione później, więc używamy fallback
      condition: !!params?.key_variable_id && !!edition1_id && !!edition2_id,
      params: [{
         edition1_id: edition1_id,
         edition2_id: edition2_id,
         key_variable_id_edition1: params.key_variable_id,
         // Używamy key_variable_id_edition2 jeśli dostępne, w przeciwnym razie tego samego ID (fallback)
         key_variable_id_edition2: params.key_variable_id_edition2 || params.key_variable_id,
         grouping_variable_id: grouping_variable_id,
         filters: params.filters
      }]
   })
}
